gi<template>
  <v-snackbar :value="alertData" timeout="5000" :color="color">{{alertData? alertData.txt:''}}
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    alertData() {
      return this.$store.getters['user/alertData']
    },
    color() {
      if (!this.alertData) return
      switch (this.alertData.type) {
        case 'failure': return '#F44336'
        case 'success': return '#4CAF50'
      }
    }
  }
}
</script>

<style>
</style>